<template>
  <div class="loginstate">
    <!-- 已登录 -->
    <ul class="login_account" v-if="logstate === true">
      <li class="msg fl">
        <a
          class="demo-badge"
          href="javascript:;"
          @click="href({ name: 'noticeList' })"
        >
          <Badge :count="info.UnreadInfoCount">
            <i></i>
          </Badge>
          <span>{{ $t("nav.w39") }}</span>
        </a>
      </li>
      <li class="msg fl">
        <router-link
          class="demo-badge"
          :to="{ name: safe.InvestOrLoaner == 2 ? 'loanOrder' : 'investOrder' }"
        >
          <Badge>
            <i class="i1"></i>
          </Badge>
          <span>{{ $t("nav.w40") }}</span>
        </router-link>
      </li>
      <li class="account fl">
        <p class="downdrop">
          <span>{{
            info.IdCardVerified ? info.RealName : info.AccountName
          }}</span>
        </p>
        <ul class="account_list">
          <li class="list_account">
            <router-link :to="{ name: 'assets' }">
              <span>{{ $t("nav.w41") }}</span>
            </router-link>
          </li>
          <li class="list_set">
            <router-link :to="{ name: 'security' }">
              <span>{{ $t("nav.w42") }}</span>
            </router-link>
          </li>
          <li class="list_manage">
            <router-link :to="{ name: 'domainManage' }">
              <span>{{ $t("nav.w43") }}</span>
            </router-link>
          </li>
          <li class="list_automatic">
            <router-link :to="{ name: 'autobid' }">
              <span>{{ $t("nav.w44") }}</span>
            </router-link>
          </li>
          <li class="list_card">
            <router-link :to="{ name: 'coupon' }">
              <span>{{ $t("nav.w45") }}</span>
            </router-link>
          </li>
          <!-- <li class="list_invite">
            <router-link :to="{name:'invite'}">
              <span>邀请好友</span>
            </router-link>
          </li> -->
          <li class="list_out">
            <a href="javascript:;" @click="loginout">
              <span>{{ $t("nav.w46") }}</span>
            </a>
          </li>
        </ul>
      </li>
      <li class="line fl"></li>
      <li class="fl">
        <Language></Language>
      </li>
    </ul>

    <!-- 未登录 -->
    <ul class="unlogin_nav" v-if="logstate === false">
      <li class="state fl" :class="{ active: this.$route.name == 'login' }">
        <router-link :to="{ name: 'login' }">{{ $t("nav.w48") }}</router-link>
      </li>
      <li
        class="state fl"
        :class="{ active: this.$route.name == 'register' }"
        :style="{ marginRight: '20px' }"
      >
        <router-link :to="{ name: 'register' }">{{
          $t("nav.w49")
        }}</router-link>
      </li>
      <li class="line fl"></li>
      <li class="fl">
        <Language></Language>
      </li>
    </ul>
  </div>
</template>

<script>
import Language from "./lang_swich"
export default {
  components: { Language },
  data() {
    return {
      num: 0,
    }
  },
  inject: ["$viewReload"],
  methods: {
    loginout() {
      this.$axios.get("/Member/RZJAuth/Logout").then((res) => {
        if (res.err) return res.throw()
        this.$Message.success(this.$t("msg.m78"))
        this.$router.push({ name: "login" })
        this.$store.commit("user/logstate", false)
        this.$store.commit("user/closeValid", true)
        this.$store.dispatch("user/getUser", "all")
      })
    },
    href(v) {
      if (this.$route.name == v.name) {
        this.$viewReload()
      } else {
        this.$router.push(v)
      }
    },
  },
  computed: {
    logstate() {
      return this.$store.state.user.logstate
    },
    info() {
      return this.$store.state.user.info
    },
    safe() {
      return this.$store.state.user.safe
    },
  },
}
</script>

<style lang="less" scoped>
.loginstate {
  width: 100%;
  height: 100%;
  .login_account {
    width: 100%;
    height: 100%;
    .msg {
      width: 120px;
      height: 100%;
      .demo-badge {
        display: block;
        font-size: 14px;
        height: 56px;
        margin: 12px 0;
        line-height: 56px;
        text-align: center;
        color: #7b7b7c;
        /deep/.ivu-badge {
          margin-right: 10px;
          i {
            vertical-align: middle;
            display: inline-block;
            width: 18px;
            height: 18px;
            background: url("../assets/nav_icons2.png") no-repeat;
            background-size: cover;
          }
          .i1 {
            background-position: 0px -18px;
          }
          .ivu-badge-count {
            right: 0px;
            top: 4px;
            padding: 0;
          }
        }
      }
    }
    .account {
      height: 100%;
      padding: 29px 0;
      margin-right: 5px;
      position: relative;
      width: 151px;
      cursor: pointer;
      &:hover,
      &:active {
        .account_list {
          display: block;
        }
      }
      .downdrop {
        font-size: 16px;
        height: 22px;
        line-height: 22px;
        margin-left: 25px;
        span {
          color: rgba(123, 123, 124, 1);
          position: relative;
          white-space: nowrap;
          &::after {
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 4px solid #7b7b7c;
            content: "";
            position: absolute;
            right: -15px;
            margin-top: -2px;
            top: 50%;
          }
        }
      }
      .account_list {
        z-index: 20;
        position: absolute;
        left: 0;
        top: 70px;
        display: none;
        > li {
          width: 151px;
          height: 40px;
          background: rgba(255, 255, 255, 1);
          a {
            display: block;
            width: 100%;
            height: 100%;
            text-align: center;
            span {
              background: url(../assets/nav_icons.png) left no-repeat;
              background-size: 16px;
              padding-left: 36px;
              display: inline-block;
              background-position: 0 0px;
              font-size: 14px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              line-height: 16px;
              color: rgba(123, 123, 124, 1);
              height: 16px;
              margin: 12px 0;
            }
          }
          &:hover {
            background: rgba(246, 249, 255, 1);
          }
        }
        .list_set {
          span {
            background-position: 0 -16px;
          }
        }
        .list_manage {
          span {
            background-position: 0 -32px;
          }
        }

        .list_automatic {
          span {
            background-position: 0 -48px;
          }
        }
        .list_card {
          span {
            background-position: 0 -64px;
          }
        }
        .list_out {
          span {
            background-position: 0 -80px;
          }
        }
        .list_invite {
          span {
            background-position: 0 -96px;
          }
        }
        &:before {
          display: block;
          content: "";
          height: 4px;
          background: linear-gradient(
            90deg,
            rgba(129, 169, 250, 1) 0%,
            rgba(74, 112, 242, 1) 100%
          );
          border-radius: 4px 4px 0px 0px;
        }
        &:after {
          display: block;
          content: "";
          height: 4px;
          border-radius: 0px 0px 4px 4px;
          background-color: #fff;
        }
      }
    }
    .line {
      width: 1px;
      margin: 27px 0;
      height: 26px;
      background: rgba(235, 235, 237, 1);
    }
  }
  .unlogin_nav {
    width: 100%;
    height: 100%;
    .state {
      width: 100px;
      height: 80px;
      margin: 24px 10px 24px 0;
      a {
        width: 100px;
        height: 32px;
        border-radius: 16px;
        display: block;
        border: 1px solid rgba(151, 151, 151, 1);
        text-align: center;
        height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(123, 123, 124, 1);
        line-height: 32px;
      }
    }
    .active {
      a {
        background: linear-gradient(
          90deg,
          rgba(129, 169, 250, 1) 0%,
          rgba(74, 112, 242, 1) 100%
        );
        color: rgba(255, 255, 255, 1);
        border: 0;
      }
    }
    .line {
      width: 1px;
      margin: 27px 0;
      height: 26px;
      background: rgba(235, 235, 237, 1);
    }
  }
}
</style>
